import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    billRequestsList: [],
    allBillRequests: [],
    billRequestMeta: {}
}

const billRequest = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default billRequest

